module.exports = __webpack_public_path__ + "img/puzzle_26.35fd1aed.png";